import { FAQ_LIST, TREND_LIST } from "@/mocks/home";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import Breaking from "./components/Breaking";
import Topics from "./components/Topics";
import Timeline from "./components/Timeline";
import Discuss from "./components/Discuss";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const schema = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: "本月大瓜",
        inLanguage: "zh-CN",
        description:
          "聚合本月大瓜爆点与本月大瓜猛料，实时跟进劲爆头条与热门焦点，提供实时热榜、话题追踪与吃瓜时间线的热点资讯站。",
      },
      {
        "@type": "ItemList",
        name: "本月大瓜实时热榜 TOP 10",
        itemListElement: TREND_LIST.slice(0, 10).map((t, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: t.title,
          description: `${t.category}话题，本月大瓜热度 ${t.heat}。`,
        })),
      },
      {
        "@type": "FAQPage",
        mainEntity: FAQ_LIST.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schema }} />
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <Breaking />
        <Topics />
        <Timeline />
        <Discuss />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}